import React, { useEffect, useRef, useState } from 'react';
import './SalesVideoStyles.css';

export default function SalesVideo() {
  const video = useRef<HTMLVideoElement>(null);
  const [needsSound, setNeedsSound] = useState(false);
  const [blocked, setBlocked] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const player = video.current;
    if (!player) return;
    let cancelled = false;
    const start = async () => {
      try {
        player.muted = false;
        await player.play();
      } catch {
        if (cancelled) return;
        player.muted = true;
        setNeedsSound(true);
        try { await player.play(); }
        catch { if (!cancelled) setBlocked(true); }
      }
    };
    void start();
    return () => { cancelled = true; player.pause(); };
  }, []);

  const listen = async () => {
    const player = video.current;
    if (!player) return;
    player.currentTime = 0;
    player.muted = false;
    try {
      await player.play();
      setNeedsSound(false);
      setBlocked(false);
    } catch { setBlocked(true); }
  };

  return <section className="cbc-sales-video" aria-labelledby="cbc-sales-video-heading">
    <h2 id="cbc-sales-video-heading">IMPORTANT: Listen to this 3-minute video. <span>(Turn up the volume)</span></h2>
    <p className="cbc-sales-video-prompt"><span aria-hidden="true">↓ </span>Find out how Calm But Capable can help you<span aria-hidden="true"> ↓</span></p>
    <div className="cbc-sales-video-frame">
      <video ref={video} autoPlay playsInline controls preload="metadata"
        poster="/cbc-side-hustle-poster.jpg"
        onError={() => setFailed(true)}
        onVolumeChange={() => { if (video.current) setNeedsSound(video.current.muted); }}
        onPlay={() => setBlocked(false)}
        aria-label="Nicholas Castle explains how Calm But Capable helps you develop your side hustle">
        <source src="/cbc-side-hustle.mp4" type="video/mp4" />
        Your browser cannot play this video. <a href="/cbc-side-hustle.mp4">Watch the video directly</a>.
      </video>
    </div>
    {failed ? <p role="status">The video could not load. <a href="/cbc-side-hustle.mp4">Open the video directly</a>.</p> :
      (needsSound || blocked) && <button className="cbc-sales-video-listen" type="button" onClick={listen}>
        {blocked ? 'Play video with sound' : 'Hear what Castle has to say — play from the start'}
      </button>}
  </section>;
}
